import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { MenuComponent } from '@fundamental-ngx/core';
import { FilterItemModel } from '../../../../core/models/misc/filter-item.model';

@Component({
    selector: '[app-interactive-th]',
    templateUrl: './interactive-th.component.html',
    styleUrls: ['./interactive-th.component.scss'],
    standalone: false
})
export class InteractiveThComponent implements OnInit, OnChanges {
	@Input() ascending = true;
	@Input() columnTitle: string;
	@Input() property: string;
	@Input() currentSortProperty: string;
	@Input() currentFilters: FilterItemModel[] = [];

	@Input() isSortable: boolean;
	@Input() sortFn: (a: any, b: any, ascending: boolean) => number;

	@Input() isFilterable: boolean;

	isActive = false;

	@ViewChild('menu')
	    menu: MenuComponent;

	@Output() sort: EventEmitter<{
		asc: boolean;
		prop: string;
		sortFn: (a: any, b: any, ascending: boolean) => number;
	}> = new EventEmitter<{ asc: boolean; prop: string; sortFn: (a: any, b: any, ascending: boolean) => number }>();
	@Output() filter: EventEmitter<string> = new EventEmitter<string>();

	@Input() isFilterIconVisible: boolean;
	@Input() isSortIconVisible: boolean;
	_isFilterIconVisible: boolean;
	
	ngOnInit() {
	    this.isActive = this.isFilterable || this.isSortable;
	}

	ngOnChanges(changes: SimpleChanges) {
	    let currentFilters = changes['currentFilters']?.currentValue;
	    if (currentFilters) {
	        this._isFilterIconVisible = this.isFiltered(currentFilters);
	        return;
	    }
	    this._isFilterIconVisible = this.isFilterIconVisible;
	}

	onSort(ascending: boolean, property: string) {
	    this.ascending = ascending;
	    this.sort.emit({ asc: ascending, prop: property, sortFn: this.sortFn });
	    this.menu.close();
	}

	onFilter(property: string) {
	    this.filter.emit(property);
	    this.menu.close();
	}

	isFiltered(currentFilters: FilterItemModel[]) {
	    if (!currentFilters) {
	        return false;
	    }
	    return currentFilters.some((item) => item.filterProperty === this.property);
	}
}
